import classes from "./CardWrapper.module.css";
import {ReactNode} from "react";

type CardWrapperProps = {
    children?: ReactNode | ReactNode[];
};

/**
 * @author Kacper Faber
 * @since 0.1.8
 * @param props
 * @constructor
 */
function CardWrapper(props: CardWrapperProps) {
    return (
        <div className={classes.wrapper}>
            { props.children }
        </div>
    );
}

export default CardWrapper;